import { render, staticRenderFns } from "./TemplateGroupsForm.vue?vue&type=template&id=e9f942f4&scoped=true"
import script from "./TemplateGroupsForm.vue?vue&type=script&lang=js"
export * from "./TemplateGroupsForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateGroupsForm.vue?vue&type=style&index=0&id=e9f942f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f942f4",
  null
  
)

export default component.exports